import { store as STORE } from '@/store'

/**
 * Tant que `passwordPolicy/mustChangePassword` est vrai, un dialog bloquant
 * (`PasswordExpiredDialog`, monté depuis `App.vue`) recouvre déjà l'écran,
 * mais ce guard empêche en plus toute navigation de fond (URL tapée
 * directement, bouton précédent/suivant du navigateur...) qui déclencherait
 * de nouvelles requêtes sur des routes authentifiées tant que le mot de passe
 * n'a pas été changé. La déconnexion reste explicitement possible : le reset
 * du store qu'elle déclenche (`AuthService.logout`) efface ce flag avant même
 * la navigation vers `signin`, mais on l'autorise ici aussi par sécurité.
 * `profile-password` est également exempté : c'est l'écran qui permet
 * justement de résoudre cet état (voir `PasswordSetting.vue` - c'est aussi
 * cet écran, avec `?forced=true&embedded=mobileapp`, que l'app mobile charge
 * en iframe pour le renouvellement forcé). `home` est exempté pour la même
 * raison que `signin` : c'est la cible de redirection de
 * `ForcedPasswordRenewalNavigationGuard` (accès à `profile-password?forced=true`
 * hors contexte mobile) - la bloquer ici empêcherait cette redirection
 * d'aboutir, alors que le dialog bloquant protège de toute façon `home` au
 * même titre que n'importe quelle autre route.
 */
export default function (to) {
	let result = true
	const isExempted = to.name === 'signin' || to.name === 'profile-password' || to.name === 'home'
	if (STORE.state.passwordPolicy.mustChangePassword && !isExempted) {
		result = false
	}
	return result
}
